export interface Team {
  name: string;
  iconUrl?: string;
}

export const dummyHomeTeam: Team = {
  name: 'Heim',
};

export const dummyGuestTeam: Team = {
  name: 'Gast',
};
